/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, uploadFile, removeFile } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "gallery";
var moduleName = "Gallery";
var modulePath = "/clientpanel/gallery";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        galleryTitle: "",
        galleryKey: "",
        galleryStatus: "",
        galleryImages: [],
        action: "add",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        url: `${ecommerceapiUrl}gallery/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          const galleryStatus = result.galleryStatus == "A" ? "Active" : "Inactive";
          const status =
            result.galleryStatus !== "" && result.galleryStatus !== null
              ? {
                  label: galleryStatus,
                  value: result.galleryStatus,
                }
              : "";
          var clientupdatedata = {
            galleryTitle: result.galleryTitle,
            galleryKey: result.galleryKey,
            galleryImages: result.galleryImages !== "" && result.galleryImages !== null ? result.galleryImages.split(",") : [],
            galleryStatus: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      galleryTitle: postData.galleryTitle,
      galleryKey: postData.galleryKey,
      galleryImages: postData.galleryImages.length > 0 ? postData.galleryImages.join(",") : "",
      galleryStatus: Object.keys(postData.galleryStatus).length > 0 ? postData.galleryStatus.value : "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method, "ecom");
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"gallery"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method, urlType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method, urlType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { galleryTitle, galleryKey, galleryStatus } = props.fields;

  return {
    fields: ["galleryTitle", "galleryKey", "galleryStatus"],
    validations: {
      galleryTitle: [[isEmpty, galleryTitle]],
      galleryKey: [[isEmpty, galleryKey]],
      galleryStatus: [[isSingleSelect, galleryStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  async uplaodFiles() {
    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#images");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "galleries", "client", "ecom");
    if (fileDetail.status === "ok") {
      var galleryImages = this.props.fields.galleryImages;
      galleryImages.push(fileDetail.url);
      this.props.onChange("galleryImages", galleryImages);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#images").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, removeIndex) {
    showLoader("ImageDetails", "class");
    var fileDetail = await removeFile(fileNamme, "client", "ecom");
    if (fileDetail.status === "ok") {
      hideLoader("ImageDetails", "class");
      var galleryImages = this.props.fields.galleryImages;
      galleryImages.splice(removeIndex, 1);
      this.props.onChange("galleryImages", galleryImages);
    }
  }

  // Function to reorder array after drag
  handleOnDragEnd = (result) => {
    console.log(result, "resultresultresultresult");
    if (!result.destination) return; // dropped outside

    const items = Array.from(this.props.fields.galleryImages);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    this.props.onChange("galleryImages", items);
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgTitle,
      errMsggalleryKey,
      errMsgStatus = "";
    if ($validation.galleryTitle.error.reason !== undefined) {
      errMsgTitle = $validation.galleryTitle.show && <span className="error">{$validation.galleryTitle.error.reason}</span>;
    }
    if ($validation.galleryKey.error.reason !== undefined) {
      errMsggalleryKey = $validation.galleryKey.show && <span className="error">{$validation.galleryKey.error.reason}</span>;
    }

    if ($validation.galleryStatus.error.reason !== undefined) {
      errMsgStatus = $validation.galleryStatus.show && <span className="error">{$validation.galleryStatus.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 mt-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgTitle !== "" && errMsgTitle !== false && errMsgTitle !== undefined ? "form-control is-invalid" : "form-control"}
                name="galleryTitle"
                value={fields.galleryTitle}
                {...$field("galleryTitle", (e) => onChange("galleryTitle", e.target.value))}
              />
              <label htmlFor="galleryTitle">
                Title <span className="error">*</span>
              </label>
              {errMsgTitle}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsggalleryKey !== "" && errMsggalleryKey !== false && errMsggalleryKey !== undefined ? "form-control is-invalid" : "form-control"}
                name="galleryKey"
                value={fields.galleryKey}
                {...$field("galleryKey", (e) => onChange("galleryKey", e.target.value))}
              />
              <label htmlFor="galleryKey">
                Key <span className="error">*</span>
              </label>
              {errMsggalleryKey}
            </div>
          </div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.galleryStatus}
                onChange={this.handleSelectChange.bind(this, "galleryStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-12">
            <div className="card mb-4">
              <h5 className="card-header">Gallery Images</h5>
              <div className="card-body">
                <div className="dz-message needsclick">
                  Drop files here or click to upload
                  <span className="note needsclick">
                    (This is just a demo dropzone. Selected files are <strong>not</strong> actually uploaded.)
                  </span>
                </div>
                <div className="fallback" id="ImageContainer">
                  <input
                    name="file"
                    type="file"
                    id="images"
                    onChange={(event) => {
                      this.uplaodFiles(event);
                      return false;
                    }}
                  />
                </div>
                {fields.galleryImages.length > 0 && (
                  <DragDropContext onDragEnd={this.handleOnDragEnd}>
                    <Droppable droppableId="gallery" direction="horizontal">
                      {(provided) => (
                        <div className="gallery" {...provided.droppableProps} ref={provided.innerRef} style={{ display: "flex", gap: "20px" }}>
                          {fields.galleryImages.map((item, index) => (
                            <Draggable key={item} draggableId={item} index={index}>
                              {(provided) => (
                                <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                  <div className="dz-details">
                                    <div className="dz-thumbnail">
                                      <img alt="" src={item} style={{ width: 150, borderRadius: 8 }} />
                                    </div>
                                  </div>
                                  <a
                                    className="dz-remove"
                                    href="#"
                                    /*  onClick={() => removeImage(item, index)} */
                                  >
                                    Remove file
                                  </a>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                )}
              </div>
            </div>
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
